"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transparent = exports.white = exports.black = exports.brick = exports.scarlet = exports.corn = exports.yellow = exports.salmon = exports.pink = exports.teal = exports.cyan = exports.blue = exports.red = exports.green = exports.orange = exports.gray = void 0;
exports.gray = {
  50: '#FAFAFA',
  100: '#F3F4F5',
  200: '#EDEFF0',
  300: '#DCDFE0',
  500: '#999C9E',
  700: '#76797A'
};
exports.orange = {
  50: '#FFEDE5',
  100: '#FFE0D3',
  500: '#FF672B',
  700: '#D65724',
  900: '#803416'
};
exports.green = {
  50: '#E4F7EC',
  100: '#DAFFF2',
  500: '#0AB356',
  700: '#219653',
  900: '#077538'
};
exports.red = {
  300: '#FAB028',
  500: '#E21A00'
};
exports.blue = {
  100: '#F4FBFF',
  500: '#0070A8'
};
exports.cyan = {
  100: '#DAFFF2',
  300: '#5EEAB8',
  500: '#4BA283'
};
exports.teal = {
  100: '#E5FDFF',
  300: '#4DD7C6',
  500: '#4AA9B9'
};
exports.pink = {
  100: '#FEEEF0',
  300: '#FDDEE1',
  500: '#FB8C98',
  700: '#FB7786',
  900: '#FB6374'
};
exports.salmon = {
  500: '#FF6D63'
};
exports.yellow = {
  50: '#FFEEB2',
  500: '#FFD013',
  700: '#F2C212',
  900: '#FFA500'
};
exports.corn = {
  100: '#FFF3D4',
  500: '#E4A400'
};
exports.scarlet = {
  300: '#EA384C',
  500: '#BE1E28',
  700: '#920D15',
  900: '#700A11'
};
exports.brick = {
  50: '#D49A86',
  500: '#AA3B2D',
  700: '#8E2507',
  900: '#7D2C00'
};
exports.black = '#232729';
exports.white = '#FFF';
exports.transparent = 'transparent';